import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC35BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_35, actualizarFC_35Estatus, actualizarFC_35Fecha,
    actualizarFileFC_35,
    agregarFileFC_35,

} from '../../../redux/DucksBeneficiario/FC_35Ducks';
import moment from 'moment'


const DocumentacionFC_35Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_35Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_35Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_35 = useSelector(store => store.FC_35Solicitud.files)
    let filesMap = useSelector(store => store.FC_35Solicitud.filesMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        const countArchivos = 1
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesGenerales 

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc35_notificacionserviciosvar: data.idfc35_notificacionserviciosvar }
            await dispatch(actualizarFC_35Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc35_notificacionserviciosvar
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_35 = 9
            const tabla = tablaFC_35
            await dispatch(actualizarFC_35Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_35())
            setEnvioCorrecto(true)
        }
    }


    React.useEffect(() => {
        if (filesFC_35.data) {
            let newFiles = []
            for (const file in filesFC_35?.data) {
                const { ...newFile } = filesFC_35?.data?.[file]
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }
    }, [data])

    /*React.useEffect(() => {
        return () => {
            dispatch(resetDataFC_35())
        }
    }, [])*/

    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_35/agregarNuevoFC_35AnexosArchivos'
        }
        const result = await dispatch(agregarFileFC_35(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_35archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_35/actualizarFormatoFC35_AnexosArchivos'
                }
                const result = await dispatch(actualizarFileFC_35(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_35/agregarNuevoFC_35AnexosArchivos'
                    }
                    result = await dispatch(agregarFileFC_35(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGPC'} tabla={"FC_35_anexos"}
                            filesMap={filesMap}
                            textLabel={`Comprobante de pago: `} textoTooltip='Comprobante de pago.'
                            idAnexoFK={data.idfc35_notificacionserviciosvar} />
                    </div>
                </Collapsible>
            </div>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {FilesGenerales()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_35Component)
